import React, { useState, useCallback, useEffect, useRef } from "react";
import "./QuizQuestion.scss";
import usg from "../Images/usg.png";
import ButtonQustion from "../Components/ButtonQustion";
import ReturnHome from "../Components/ReturnHome";
import ProgressBarComponent from "../Components/ProgressBarComponent";
import ModalCover from "../Components/ModalCover";
import ModalTextDisplay from "../Components/ModalTextDisplay";
import ModalButtonsDisplay from "../Components/ModalButtonsDisplay";
import { useParams, useNavigate } from "react-router";
import getScore from "../Utils/getScore";
import viewNavigate from "../Utils/viewNavigate";
import useIdle from "../Hooks/useIdle";
/**
 * @param {} q
 * @returns {Array}
 */
const arrayAnswers = (q) => {
  const arr = [];
  for (let i = 1; i < 5; i++) {
    const answer = q[`Answer ${i}`];
    if (answer.length < 1) {
      continue;
    }
    arr.push(answer);
  }
  return arr;
};
let tryCount = 0;
const compareAnswers = (selectedQuestion, question) => {
  const answerString = `Answer ${selectedQuestion}`;
  const correctAnswer = question["Correct Answer"];
  return answerString === correctAnswer;
};
const wasSelected = (selectedQuestion, question) => {
  const answerString = `Answer ${selectedQuestion}`;
  const correctAnswer = question["playerAnswer"];
  const correctAnswer2 = question["playerAnswer2"];
  return answerString === correctAnswer || answerString === correctAnswer2;
};
const totalCounter = 30;
const QuizQuestion = (props) => {
  const isIdle = useIdle();
  const setTimeoutlId = useRef(null);
  let navigate = useNavigate();
  const [blockButtons, setBlockButtons] = useState(false);
  const [score, setScore] = useState(0);
  const [tryAgain, setTryAgain] = useState(false);
  const [showTruth, setShowTruth] = useState(false);
  const [skip, setSkip] = useState(false);
  const [retunHome, setRetunHome] = useState(false);
  const [timeIsOver, setTimeIsOver] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [counter, setCounter] = useState(totalCounter);
  let params = useParams();
  /**@type {Array} */
  const responses = props.responses;
  const id = parseInt(params.id);
  const question = responses[id];
  useEffect(() => {
    tryCount = 0;
  }, []);
  useEffect(() => {
    setScore(getScore(responses));
  }, [responses]);
  useEffect(() => {
    if (selectedQuestion === null) {
      return;
    }

    const answerString = `Answer ${selectedQuestion}`;
    const correctAnswer = question["Correct Answer"];
    if (!question["playerAnswer"]) {
      question["playerAnswer"] = answerString;
    } else {
      question["playerAnswer2"] = answerString;
    }
    props.setResponses([...responses]);
    // correct
    console.log(tryCount, answerString, correctAnswer);
    if (answerString === correctAnswer) {
      question["score"] = Math.floor(
        ((counter / totalCounter) * 1000) / (1 + !!question["playerAnswer2"])
      );
      props.setResponses([...responses]);
      setBlockButtons(true);
      clearTimeout(setTimeoutlId.current);
      setShowTruth(true);
      setTimeout(() => {
        setBlockButtons(false);
        viewNavigate(navigate, `/Explanation/${id}`, { viewTransition: true });
      }, 2000);
    } else if (tryCount === 0 && arrayAnswers(question).length > 2) {
      setTryAgain(true);
      setTimeout(() => {
        setTryAgain(false);
      }, 3000);
      tryCount++;
    } else {
      setBlockButtons(true);
      setShowTruth(true);
      clearTimeout(setTimeoutlId.current);
      setTimeout(() => {
        setBlockButtons(false);
        viewNavigate(navigate, `/Explanation/${id}`);
      }, 5000);
    }
  }, [selectedQuestion]);
  useEffect(() => {
    setTimeoutlId.current = setTimeout(() => {
      if (counter < 0) {
        setTimeIsOver(true);
        setTryAgain(false);
        setSkip(false);
        setRetunHome(false);
      } else {
        setCounter(counter - 1);
      }
    }, 1000);
    return () => {
      clearTimeout(setTimeoutlId.current);
    };
  }, [counter]);
  useEffect(() => {
    if (!timeIsOver) {
      return;
    }
    setTimeout(() => {
      viewNavigate(navigate, `/Explanation/${id}`);
    }, 2000);
  }, [timeIsOver]);
  // console.log(question["Question Image"], question, responses);
  const progress = (100 * counter) / 30;
  return (
    <div className="quiz-container">
      {tryAgain && (
        <ModalCover
          style={{ backgroundColor: "transparent" }}
          onClick={() => setTryAgain(false)}
        >
          <ModalTextDisplay text={"Try again!"} />
        </ModalCover>
      )}
      {skip && (
        <ModalCover>
          <ModalButtonsDisplay
            title={"Are you sure?"}
            text={"You won’t get any points for this question."}
            denyText={"Go Back"}
            deny={() => {
              setSkip(false);
            }}
            accept={() => {
              viewNavigate(navigate, `/Explanation/${id}`);
            }}
            acceptText={"Yes"}
          />
        </ModalCover>
      )}
      {retunHome && (
        <ModalCover>
          <ModalButtonsDisplay
            title={"Are you sure?"}
            text={"The game will end, and you can start a new session."}
            denyText={"Cancel"}
            deny={() => {
              setRetunHome(false);
            }}
            accept={() => {
              viewNavigate(navigate, `/`);
            }}
            acceptText={"Retun To Home"}
          />
        </ModalCover>
      )}
      {timeIsOver && (
        <ModalCover onClick={() => {}}>
          <ModalTextDisplay text={"Oops! Time is over."} />
        </ModalCover>
      )}
      <div className="quiz-score">
        Score: <span className="score-value">{score}</span>
      </div>
      <div className="question-central-holder">
        <h2 className="question-title">
          Question {id + 1}/{responses.length}
        </h2>
        <p className="question-text">{question["Question text"]}</p>
        <div className="image-container">
          {question["Question Image"].endsWith(".png") ||
          question["Question Image"].endsWith(".jpg") ? (
            <img src={question["Question Image"]} alt="Ultrasound Image" />
          ) : (
            <video loop={true} autoPlay={true} muted={true}>
              <source
                src={question["video_blob"] ? question["video_blob"] : question["Question Image"]}
                type={`video/${question["Question Image"].slice(-3)}`}
              />
            </video>
          )}
        </div>
        <div className="options-questions">
          {arrayAnswers(question).map((elem, index) => {
            console.log(
              `${index}${wasSelected(index + 1, question)} ${showTruth} ${
                selectedQuestion !== index + 1 &&
                (!showTruth || !wasSelected(index + 1, question)) &&
                !timeIsOver
              }`
            );
            return (
              <ButtonQustion
                disabled={blockButtons}
                onClick={() => setSelectedQuestion(index + 1)}
                key={elem}
                answerIndex={
                  selectedQuestion !== index + 1 &&
                  (!showTruth ||
                    (!wasSelected(index + 1, question) &&
                      !compareAnswers(index + 1, question))) &&
                  !timeIsOver
                    ? "unselected"
                    : compareAnswers(index + 1, question)
                    ? "correct"
                    : "wrong"
                }
              >
                {elem}
              </ButtonQustion>
            );
          })}
        </div>
        <ProgressBarComponent
          class={
            progress > 50
              ? "progress-bar-high"
              : progress > 25
              ? "progress-bar-middle"
              : "progress-bar-low"
          }
          progress={progress}
        />
      </div>
      <div className="flex-quiz"></div>
      <div className="bottom-actions">
        <ReturnHome onClick={() => setRetunHome(true)} />
        <button onClick={() => setSkip(true)} className="skip-button-question">
          I Don’t Know, Skip
        </button>
      </div>
    </div>
  );
};

export default QuizQuestion;
